import HTMLReactParser from 'html-react-parser'
import { Mail, Phone, Users } from 'lucide-react'
import React from 'react'

const DemoDetailsContact = ({ demo, publicContactIsVisible }) => {
    return (
        <div>


            <><div className="hidden space-x-5 border-x border-y border-neutral-900 flex bg-neutral-800/30 p-3 rounded-3xl">


                <div className="border-x border-y border-neutral-800 basis-2/12 flex flex-col  items-center  p-3 rounded-3xl shadow-md  space-x-2">
                    <div className="">
                        <img className="rounded-full w-32" src={demo.contact?.photos.small} alt="" /> </div>
                    <div>

                        <h3 className="text-2xl font-bold mb-2 hidden">
                            {/* {t('global.contact')} */}
                            Contact </h3>
                        <p className="pt-3"> {demo.contact?.nom} {demo.contact?.prenom}</p>
                        <p> {demo.contact?.fonction} </p>
                    </div>
                </div>
                <div className="basis-10/12">
                    <p className="p-2">{HTMLReactParser(demo.contact?.edito_long ?? "")}</p>
                </div>
            </div>


                {/* About SKILLKKORP */}
                <section className="py-10 px-4 bg-neutral-50">
                    <div className="  mx-auto">
                        <div className="max-w-4xl mx-auto">
                            <h2 className="text-3xl font-bold text-neutral-900 mb-8 text-center">À propos de {demo.contact?.societe} </h2>

                            <div className="bg-white border-neutral-200 mb-8 shadow-sm p-10">
                                <div>
                                    <div className="text-neutral-900 flex items-center text-xl font-semibold mb-4">
                                        <Users className="w-5 h-5 mr-2 text-cyan-500" />
                                        Contact
                                    </div>
                                </div>
                                <div>
                                    <div className="flex items-center space-x-4">
                                        <img className="rounded-full w-32 h-32 object-cover" src={demo.contact?.photos.small} alt="" />
                                        <div>
                                            <p className="text-neutral-900 font-semibold"> {demo.contact?.nom} {demo.contact?.prenom}</p>
                                            <p className="text-cyan-500 text-sm">CEO</p>
                                            {publicContactIsVisible && <div className="flex items-center space-x-4 mt-2 text-neutral-600 text-sm">
                                                <div className="flex items-center">
                                                    <Phone className="w-4 h-4 mr-1" />
                                                    {demo.contact?.port}
                                                </div>
                                                <div className="flex items-center">
                                                    <Mail className="w-4 h-4 mr-1" />
                                                    {demo.contact?.mail}
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </>



        </div>
    )
}

export default DemoDetailsContact